// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
// import Vue from "vue";
import App from './App';
Vue.prototype.vue = Vue;

import router from './router';
router.beforeEach((to, from, next) => {
  const token = Vue.prototype.func.getToken();
  if (token) {
    next();
  } else {
    //没有登录，去跳转登录页
    if (to.path === '/account/login') {
      next();
    } else {
      location.href = location.origin + "#/account/login";
      next();
    }
  }
})
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

import addComponents from "./components/shared/high-components";
Vue.use(addComponents);
// import VueI18n from 'vue-i18n';
// Vue.use(VueI18n) // 通过插件的形式挂载
// const i18n = new VueI18n({
//   locale: 'zh-CN', // 语言标识
//   messages: {
//     'zh-CN': require('../static/i18n/all_zh-CN.json'), // 中文语言包
//     'en-US': require('../static/i18n/all_en-US.json') // 英文语言包
//   }
// })

// import ElementUI from 'element-ui';
// Vue.use(ElementUI, {size: 'small' })
Vue.prototype.$ELEMENT = { size: 'small' }


import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  bgOpacity: 0.5,
  zoomEl: true,
};
Vue.use(preview, options)

// import Print from 'vue-print-nb'
// Vue.use(Print);

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber);

import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)


//封装的axios
import axios from "@/server/index.js";
Vue.prototype.$axios = axios.axios;
import server from '@/server/https.js';
Vue.prototype.https = server.https;
Vue.prototype.httpUpload = server.httpUpload;
Vue.prototype.httpDownload = server.httpDownload;
Vue.prototype.envConfig = axios.envConfig;

import websocket from '@/server/websocket.js';
Vue.prototype.websocket = websocket;

//自定义指令
import "@/utils/directive.js";
import "@/utils/filter.js";
import func from "@/utils/func.js";
Vue.prototype.func = func;


/*引入模块公共样式*/
import "../../assets/style/theme.scss";
import "../../assets/font/iconfont.css"
import "../../assets/style/style.css";
import "./assets/css/style.css";

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)


Vue.prototype.$bus = new Vue();
import store from "@/vuex/store.js";

new Vue({
  el: '#app',
  store,
  // i18n,
  router,
  data() {
    return {
      userInfo: {
        wStatus: null, // 1，未绑定账号  2 已登录 
        roles: [],
      },
      tenantInfo: {},
      loadingBox: null,
      wxDialogVisible: false,
      qrContent: "",
    }
  },
  created() {
    this.userInfo = this.func.getUserInfo();
    this.tenantInfo = this.func.getSession("tenantInfo") || {
      code: this.userInfo.tenantCode || this.func.getSession("tenantCode") || tenantCode,
    };
    this.setHtmlHead();
    if (this.userInfo.token) {
      this.getUserBaseInfo();
    }
    this.getTenantInfo();
  },
  methods: {
    getUserBaseInfo(callback) {
      this.userInfo.token = this.func.getUserInfo().token || this.userInfo.token;
      let params = {
        token: this.userInfo.token
      }
      this.https("get", "/api/User/GetInfoByToken", params).then(res => {
        if (res.success) {
          this.userInfo = Object.assign(this.userInfo, res.response || {});
          this.userInfo.childrenRole = this.userInfo.childrenRole.filter(item => item.code && item.roleName);
          this.userInfo.roles = this.userInfo.childrenRole.filter(item => item.roleId).map(item => { return item.code });
          this.userInfo.isAdmin = !!this.userInfo.childrenRole.find(item => item.code == 'admin') || this.userInfo.type == -1;
          this.userInfo.subjectCatalogueNames = this.userInfo.subjectCatalogues.map(item => { return item.name }).join("、");
          this.userInfo.pcHome = this.userInfo.pcHome || "/";
          this.userInfo.msHome = this.userInfo.msHome || "/";
          this.https("get", "/api/Permission/GetNavigationBar", {
            parentId: 0,
            permissionPlatform: "pc",
            tenantCode: this.tenantInfo.code,
          }).then(data => {
            let menus = data.response ? data.response.children || [] : [];
            this.userInfo.hasAdmin = menus.findIndex(item => item.path == "/ms") >= 0;
            for (let i = 0; i < menus.length; i++) {
              if (menus[i].path != "/ms") {
                if (menus[i].children && menus[i].children.length > 0) {
                  this.userInfo.pcHome = menus[i].children[0].path;
                } else {
                  this.userInfo.pcHome = menus[i].path;
                }
                break;
              }
            }
            this.func.setSession("userInfo", this.userInfo);
            this.$bus.$emit("Update_UserInfo", this.userInfo);
            if (typeof callback == "function") {
              callback(this.userInfo);
            }
            if (this.tenantInfo.code !== this.userInfo.tenantCode || sessionStorage.tenantCode != this.userInfo.tenantCode) {
              this.tenantInfo.code = this.userInfo.tenantCode;
              this.getTenantInfo();
            }
          }).catch(res => {
            if (typeof callback == "function") {
              callback(this.userInfo);
            }
          })
        } else {
          this.func.message("error", res.msg);
          if (typeof callback == "function") {
            callback(this.userInfo);
          }
        }
      }).catch(res => {
        if (typeof callback == "function") {
          callback(this.userInfo);
        }
      })
    },
    getTenantInfo() {
      let params = {
        tenantCode: this.tenantInfo.code,
      }
      let url = "/api/Tenant/GetTenantConfig";
      if (this.userInfo.token) {
        params = {
          code: this.tenantInfo.code,
        }
        url = "/api/Tenant/GetByCode";
      }
      this.https("get", url, params).then(res => {
        let data = res.response || {};
        data.name = data.name || data.tenantName;
        data.logoUrl = data.logoUrl || data.tenantLogoUrl;
        data.bigLogoUrl = data.bigLogoUrl || data.tenantBigLogoUrl;
        data.type = data.type || data.tenantType;
        try {
          data.parameter = JSON.parse(data.parameter) || {};
        } catch (error) {
          data.parameter = {};
        }
        this.tenantInfo = Object.assign(this.tenantInfo, data);
        this.setHtmlHead();
        this.func.setSession("tenantInfo", this.tenantInfo);
        this.$bus.$emit("Update_TenantInfo", 1);
      })
    },
    setHtmlHead() {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = this.tenantInfo.logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
      document.title = this.tenantInfo.name || "";
      this.$forceUpdate();
    },
    fullLoading(text, target) {
      this.loadingBox = this.$loading({
        lock: true,
        target,
        customClass: "full-loading",
        text: text || '操作中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
    },
    closeLoading() {
      this.loadingBox.close();
    },
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/pc/main.js